import { Card, CardContent } from "@/components/ui/card";
import { Route as patientsOneRoute } from "@/routes/(pharma)/_layout/patients/patient-info/$patientId";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import { convertToCurrencyRounded } from "@/utils/currency_converter";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";

interface CSVDataItem {
  invoice_id: string;
  created_at: string;
  sales_amount: string;
}

export default function QuickActions() {
  const { patientInfo, patientSales } = patientsOneRoute.useLoaderData();
  const [csvData, setCSVData] = useState<CSVDataItem[]>([]);
  const [isDataAvailable, setIsDataAvailable] = useState<boolean>(false);
  const headers = [
    { label: "Invoice Id", key: "invoice_id" },
    { label: "Created Date", key: "created_at" },
    { label: "Billed Amount", key: "sales_amount" },
  ];

  useEffect(() => {
    if (patientSales.sales.length > 0) {
      const csvDataItems: CSVDataItem[] = patientSales.sales.map((item) => ({
        invoice_id: item.receiptNumber,
        created_at: dayjs(item.saleValues?.createdAt?.toDate()).format("DD/MM/YYYY"),
        sales_amount: convertToCurrencyRounded(
          item.saleValues?.grandTotalAmount || 0,
        )?.toString() || "0.00",
      }));
      setCSVData(csvDataItems);
      setIsDataAvailable(true); // Set flag to true when data is available
    } else {
      setIsDataAvailable(false); // Set flag to false when no data is available
    }
  }, [patientSales.sales]);

  const filename = "patients_sales_history.csv";

  return (
    <Card className="mt-6 sticky bottom-0 overflow-hidden rounded-xl shadow-transparent ml-4">
      <CardContent className="flex gap-2 p-4 space-y-0">
        <div className="ml-auto">
          {isDataAvailable ? (
            <CSVLink
              data={csvData}
              headers={headers}
              filename={filename}
              className="inline-block" // To make sure the button styles are applied correctly
            >
              <Button
                size="sm"
                variant="ghost"
                className="gap-1 bg-black text-white border border-gray-200 rounded-lg"
              >
                <Download className="p-1" />
                Export Patients Transactions
              </Button>
            </CSVLink>
          ) : (
            <Button
              size="sm"
              variant="ghost"
              className="gap-1 bg-gray-300 text-gray-700 border border-gray-200 rounded-lg cursor-not-allowed"
              disabled
            >
              <Download className="p-1" />
              Export Patients Transactions
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
